import { Component, ViewEncapsulation, OnInit, Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { AppService } from '../../../app.service';
import { Product } from '../../../app.models';
import { DownloadAppComponent } from '../../downloadApp/downloadApp.component';
import { Router } from '@angular/router';
import { Settings, AppSettings } from '../../../app.settings';
import { MatDialog } from '@angular/material';


// ******************************************************* PRODUCT DIALOG COMPONENT CLASS *********************************************
@Component({
  selector: 'app-product-dialog',
  templateUrl: './product-dialog.component.html',
  styleUrls: ['./product-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProductDialogComponent implements OnInit {
  public config: SwiperConfigInterface = {};
  constructor(public appSettings: AppSettings, public appService: AppService, public dialog: MatDialog, private router: Router,
              public dialogRef: MatDialogRef<ProductDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public product: Product) {
    this.settings = this.appSettings.settings;
  }


  public settings: Settings;


  // -- FUNC Ng On Init
  ngOnInit() { }


  // -- FUNC Ng After View Init
  ngAfterViewInit(){
    this.config = {
      slidesPerView: 1,
      spaceBetween: 0,         
      keyboard: true,
      navigation: true,
      pagination: false,
      grabCursor: true,        
      loop: false,
      preloadImages: false,
      lazy: true, 
      effect: "fade",
      fadeEffect: {
        crossFade: true
      }
    }
  }


  // -- FUNC Open Download App Page
  public openDownloadAppPage() {
    let dialogRef = this.dialog.open(DownloadAppComponent, {
      data: null,
      panelClass: 'product-dialog',
      direction: (this.settings.rtl) ? 'rtl' : 'ltr'
    });
    dialogRef.afterClosed().subscribe(product => {
    });
  }


  // -- FUNC Close
  public close(): void {
    this.dialogRef.close();
  }


  // -- FUNC Open Product Page
  public openProductPage(product: Product) {
    if (product) {
      this.router.navigate(['/products', 'product', product.productID, product.productName
        ]);
    }

  }
}
